/**
 * parses a relative url (without baseUrl) and splits it into culture, path and query.
 * @param url url to be parsed.
 */
export function parseUrl(url: string): {
  culture?: string;
  path?: string;
  query?: string;
} {
  const match = url.match(
    /^\/?([a-zA-Z]{2}-[a-zA-Z]{2})?([/]?[^?#]*)(\?[^#]*|)$/,
  );
  return {
    culture: match?.[1],
    path: match?.[2],
    query: match?.[3],
  };
}

/**
 * removes html tags from a string that contains text-content and html tags.
 * Example: '<div>One <p class="exampleClass">two</p> three</div>' => 'One two three'
 * @param htmlText text from which html tags need to be removed.
 */
export function removeHtmlTagsFromString(htmlText: string): string {
  return htmlText?.replace(/(<([^>]+)>)/gi, '');
}
